import React from "react";
import "../css/styles.css"; // Add styles separately

const FullPageLoader = () => (
  <div className="fullpage-loader">
    <div className="spinner-border text-light" role="status" />
  </div>
);

export default FullPageLoader;
